<div class="flex flex-col h-screen">
  <app-header (toggleSidebar)="toggleSidebar()"></app-header>

  <div class="flex flex-1 overflow-hidden">
    <app-sidebar [isSidebarOpen]="isSidebarOpen"></app-sidebar>

    <div class="flex-1 overflow-y-auto p-6 mt-16 ml-0 md:ml-64">
      <ng-content></ng-content>

      <app-confirm-modal
      *ngIf="isModalOpen"
      [title]="'Invitation Request'"
      [message]="modalMessage"
      [showConfirmButton]="true"
      (cancel)="closeModal()"
      (confirm)="acceptControllerInvite(uniqueKey)"
      >
      </app-confirm-modal>

      <router-outlet></router-outlet>
    </div>
  </div>
</div>
